module.exports = __webpack_public_path__ + "static/media/trinity.7447c5f6.png";